import {
    Box,
    Card,
    Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import theme from 'src/theme/light';
import { ResumoMobile } from './resumoMobile';
import { TipoPropostaMobile } from './tipoPropostaMobile';
import { ListagemItensSolucaoMobile } from './listagemItensSolucaoMobile';
interface SolucaoMobileProps {
  handleOpenModalEstruturas: () => void
  handleChangeModulo: (moduloId: number) => void
}
const useStyles = makeStyles({
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        margin: theme.spacing(2),
        gap: theme.spacing(2),
    },
    cardItens: {
        paddingTop: "10px",
        borderRadius: 8,
    },
    cardTipoProposta: {
        borderRadius: 8,
    },
    cardResumo: {
        borderRadius: 8,
    },
    title: {
        fontSize: "25px",
        fontWeight: "bold"
    },
    titleContainer: {
        display: "flex",
        flexDirection: "row",
        alignContent: "flex-start"
    }
})
export const SolucaoMobile = ({ handleOpenModalEstruturas, handleChangeModulo }: SolucaoMobileProps) => {
    const classes = useStyles();
    return <Box className={classes.mainContainer}>
        <Box className={classes.titleContainer}>
            <Typography className={classes.title}>Solução</Typography>
        </Box>
        <Card className={classes.cardItens}>
            {/* card itens*/}
            <ListagemItensSolucaoMobile handleOpenModalEstruturas={handleOpenModalEstruturas} handleChangeModulo={(moduloId: number)=>handleChangeModulo(moduloId)}/>
        </Card>
        <Card className={classes.cardTipoProposta}>
            {/* card tipo serviço*/}
            <TipoPropostaMobile />
        </Card>
        <Card className={classes.cardResumo}>
            {/* card Resumo*/} 
            <ResumoMobile />
        </Card>
    </Box>
}